import { render, staticRenderFns } from "./ModuleMonitorV2.vue?vue&type=template&id=da95305c&scoped=true&"
import script from "./ModuleMonitorV2.vue?vue&type=script&lang=js&"
export * from "./ModuleMonitorV2.vue?vue&type=script&lang=js&"
import style0 from "./ModuleMonitorV2.vue?vue&type=style&index=0&id=da95305c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da95305c",
  null
  
)

export default component.exports